import React from 'react';
import { useSelector } from 'react-redux';
import { useMatch } from 'react-router-dom';
import clsx from 'clsx';

import { userSelectors } from 'reducers';
import { roleCategories } from 'utils/constants';
import { titles } from 'utils/formData';
import { texts } from 'utils/languages/fr';

import { CustomSelect, CustomTextField } from 'components';
import { MenuItem } from '@mui/material';
import { useGetReferralParameters, useUserRoleMatchCategory } from 'utils/hooks';

const renderOption = opt => (
    <MenuItem key={opt} value={opt}>
        {opt}
    </MenuItem>
);

const BasicInfoForm = props => {
    const {
        classes,
        form,
        handleChange,
        user,
        errors,
        tunnelErrors = {},
        emailExists,
        coSubscriber,
        isDisabled = false,
    } = props;
    const isCreatingSubscription = !!useMatch('/create-subscription/*');
    const isOnClientSpace = !!useMatch('/my-account');
    const isOnAdminSpace = !!useMatch('/investor-accounts/*');

    const internalUser = useSelector(userSelectors.getInternalUser);
    const userIsServicer = useUserRoleMatchCategory(roleCategories.SERVICERS);

    const {
        email: queryEmail,
        firstName: queryFirstName,
        lastName: queryLastName,
        title: queryTitle,
    } = useGetReferralParameters();

    const isImpersonated = !!internalUser?.impersonatedByUser;
    const disableFields =
        (!userIsServicer && isOnAdminSpace) || (isOnClientSpace && !isImpersonated) || isDisabled;

    return (
        <React.Fragment>
            <CustomSelect
                inputStyle={classes.field}
                label={texts.CIVILITE}
                value={form.title}
                onChange={handleChange('title')}
                disabled={disableFields || !!queryTitle}
            >
                {titles.map(renderOption)}
            </CustomSelect>
            <CustomTextField
                inputStyle={classes.field}
                label={texts.PRENOM}
                value={form.firstName}
                onChange={handleChange('firstName')}
                error={errors.firstName || tunnelErrors.firstName}
                showError={!tunnelErrors.firstName}
                disabled={disableFields || !!queryFirstName}
            />
            <CustomTextField
                inputStyle={classes.field}
                disabled={!!queryLastName}
                label={texts.NOM}
                value={form.lastName}
                onChange={handleChange('lastName')}
                error={errors.lastName || tunnelErrors.lastName}
                showError={!tunnelErrors.lastName}
            />
            {!coSubscriber && (
                <CustomTextField
                    inputStyle={clsx(classes.field, classes.indentedField)}
                    label={texts.NOM_DE_NAISSANCE}
                    value={form.birthName}
                    onChange={handleChange('birthName')}
                    error={errors.birthName || tunnelErrors['birthName']}
                    showError={!tunnelErrors['birthName']}
                    disabled={disableFields}
                />
            )}
            <CustomTextField
                type="email"
                inputStyle={classes.field}
                label={texts.E_MAIL}
                value={queryEmail || form.email}
                disabled={
                    !userIsServicer &&
                    (coSubscriber
                        ? isOnClientSpace || (!userIsServicer && isOnAdminSpace)
                        : true) &&
                    ((!!user &&
                        !isCreatingSubscription &&
                        (isOnClientSpace ? !isImpersonated : true)) ||
                        !!queryEmail)
                }
                onChange={handleChange('email')}
                error={emailExists ? texts.CETTE_ADRESSE_EXISTE_DEJA : errors.email}
            />
        </React.Fragment>
    );
};

export default BasicInfoForm;
